/**
 * utils
 * @authors longfei5 (longfei5@staff.weibo.com)
 * @date    2018-07-03 16:33:06
 * @version $Id$
 */
/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
export const formatFileSize = (size) => {
  const units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const threshold = 1024
  size = Number(size) * threshold
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold))
  return `${(size / Math.pow(threshold, i)).toFixed(2) * 1} ${units[i]}`
}

/**
 * Checks if vee-validate is defined globally.
 */
export const isDefinedGlobally = () => {
  return typeof VeeValidate !== 'undefined'
}
export function getData(url, data, callback, errorCallback, showLoading = true) {
  // 获取数据
  if (!url) return
  if (showLoading) {
    var loading = Vue.prototype.$loading({
      lock: true,
      text: '处理中...',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)'
    });
  }
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  axios.interceptors.response.use((response) => {
    return response
  }, function (error) {
    if (error.response.status === 401) {
      // const searchValueObj = qs.parse(window.location.search.replace('?', ''));
      if (window.location.host.includes('brand')) {
        window.location.href = 'http://cas.erp.sina.com.cn/cas/login?service=' + window.location.origin + '/api/brand/index' + window.location.search;
      } else {
        window.location.href = '/api/userinfo/autologin?url=' + encodeURIComponent(window.location.href)
      }
    }
    if (error.response.status == 403) {
      showLoading && Vue.prototype.$message.warning(error.response.data.message)
      return Promise.reject(error)
    }
    else {
      return Promise.reject(error)
    }
  })
  return axios
    .get(url, {
      params: data
    })
    .then(function (response) {
      callback && callback(response.data)
      if (response.data.code == 20001) {
        showLoading && Vue.prototype.$message.warning(response.data.msg)
        setTimeout(() => {
          window.location.href = '/'
        }, 500)
        return
      }
      showLoading && loading.close()
    })
    .catch(function (error) {
      errorCallback && errorCallback(error)
      showLoading && loading.close()
    })
}

export function saveData(url, data, callback, errorCallback, showLoading = true) {
  if (!url) return
  if (showLoading) {
    var loading = Vue.prototype.$loading({
      lock: true,
      text: '处理中...',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)'
    });
  }
  let params = new URLSearchParams()
  for (let prop in data) {
    if (data[prop] instanceof Array) {
      data[prop].forEach(e => {
        if (e instanceof Object) {
          let _params = new URLSearchParams()
          for (const k in e) {
            if (e[k]) {
              _params.append(k, e[k])
            }
          }
          params.append(prop + '[]', _params)
        } else {
          params.append(prop + '[]', e)
        }
      })
    } else {
      params.append(prop, data[prop])
    }
  }
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  axios.interceptors.response.use((response) => {
    return response
  }, function (error) {
    if (error.response.status == 401) {
      if (window.location.host.includes('brand')) {
        window.location.href = 'http://cas.erp.sina.com.cn/cas/login?service=' + window.location.origin + '/brand/index' + window.location.search;
      } else {
        window.location.href = '/api/userinfo/autologin?url=' + encodeURIComponent(window.location.href)
      }
    } else {
      return Promise.reject(error)
    }
  })
  return axios
    .post(url, params)
    .then(function (response) {
      let result = response.data
      showLoading && loading.close()
      if (result.code != 0) {
        showLoading && Vue.prototype.$message.warning(result.msg)
        if (result.code != 10013) {
          errorCallback && errorCallback(result)
        }
        return
      }
      callback && callback(result)
    })
    .catch(function (error) {
      errorCallback && errorCallback(error)
      showLoading && loading.close()
    })
}

export function isEmpty(obj) {
  if (obj === null) return true
  if (obj.length > 0) return false
  if (obj.length === 0) return true
  if (typeof obj !== 'object') return true
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/utils.js